import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function Sitemap() {
  return (
    <div className="sitemap-container-page" style={{ 
      padding: 'clamp(20px, 5vw, 40px) clamp(10px, 3vw, 20px)', 
      backgroundColor: '#f4f8fb', 
      minHeight: '100vh', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      <Helmet>
        <title>Sitemap | Medical Trip World Operational Portal Structure</title>
        <meta name="description" content="Explore the full layout of Medical Trip World. Access treatment directories, visa files, guidelines, and patient resources." />
      </Helmet>

      {/* HERO SECTION */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h2 className="sitemap-main-title" style={{ 
          color: '#0b3c5d', 
          fontSize: 'clamp(1.6rem, 6vw, 2.5rem)', 
          fontWeight: '700', 
          margin: '0 0 10px 0',
          lineHeight: '1.2'
        }}>
          Portal Architecture Roadmap
        </h2>
        <p style={{ color: '#555', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', maxWidth: '700px', margin: '0 auto', lineHeight: '1.6' }}>
          Quickly discover system paths, clinical directories, patient utilities, and documentation checklists organized within the <strong>Medical Trip World</strong> independent reference directory framework.
        </p>
      </div>

      {/* MULTI-COLUMN INTERACTIVE CARD GRID */}
      <div className="sitemap-grid-system" style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(290px, 1fr))', 
        gap: '20px', 
        maxWidth: '1200px', 
        margin: '0 auto',
        boxSizing: 'border-box'
      }}>
        
        {/* CARD 1: MAIN NAVIGATION */}
        <div className="sitemap-block" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', borderTop: '4px solid #0b3c5d', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#0b3c5d', fontSize: '1.2rem', marginTop: '0', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1.4' }}>
            🌐 Core Navigation & Organization
          </h3>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <li><Link to="/" style={{ color: '#005ba1', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Home Portal Index</Link></li>
            <li>
              <Link to="/about" style={{ color: '#005ba1', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>About the Organisation</Link>
              <ul style={{ paddingLeft: '18px', marginTop: '6px', listStyle: 'circle', color: '#666', fontSize: '0.9rem', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <li><Link to="/about#org" style={{ color: 'inherit', textDecoration: 'none', display: 'inline-block', minHeight: '32px' }}>Organization History</Link></li>
                <li><Link to="/about#mandate" style={{ color: 'inherit', textDecoration: 'none', display: 'inline-block', minHeight: '32px' }}>Mandate & Core Objectives</Link></li>
                <li><Link to="/about#vision" style={{ color: 'inherit', textDecoration: 'none', display: 'inline-block', minHeight: '32px' }}>Vision & Mission Statements</Link></li>
              </ul>
            </li>
          </ul>
        </div>

        {/* CARD 2: MEDICAL DIRECTORY */}
        <div className="sitemap-block" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', borderTop: '4px solid #28a745', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#28a745', fontSize: '1.2rem', marginTop: '0', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1.4' }}>
            🏥 Popular Treatments & Specialties
          </h3>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.95rem' }}>
            <li><Link to="/treatments" style={{ color: '#333', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Medical Directory Overview →</Link></li>
            <li><Link to="/cardiology" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Cardiology (Heart Surgery Operations)</Link></li>
            <li><Link to="/orthopedics" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Orthopedics & Spine Replacements</Link></li>
            <li><Link to="/oncology" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Oncology (Advanced Cancer Treatment)</Link></li>
            <li><Link to="/dental" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Dental Tourism & Maxillofacial Implants</Link></li>
          </ul>
        </div>

        {/* CARD 3: VISA HELP DESK */}
        <div className="sitemap-block" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', borderTop: '4px solid #ff9f1c', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#ff9f1c', fontSize: '1.2rem', marginTop: '0', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1.4' }}>
            🛂 Immigration & Visa Frameworks
          </h3>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.95rem' }}>
            <li><Link to="/guides" style={{ color: '#333', fontWeight: 'bold', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Visa Guidelines Main Hub</Link></li>
            <li><Link to="/guides#apply" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Online Medical Visa Application Guide</Link></li>
            <li><Link to="/guides#format" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Format of Documentation Registration</Link></li>
            <li><Link to="/guides#status" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Search Real-time Application Status</Link></li>
            <li><Link to="/travel-advisories" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Advisories & Health Regulations</Link></li>
          </ul>
        </div>

        {/* CARD 4: CLINICAL DIVISION NETWORKS */}
        <div className="sitemap-block" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', borderTop: '4px solid #005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#005ba1', fontSize: '1.2rem', marginTop: '0', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1.4' }}>
            📋 Quality Audits & Divisions
          </h3>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.95rem' }}>
            <li><Link Magic to="/guides#framework" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>The Protection of Patient Rights Act</Link></li>
            <li><Link to="/hospitals" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Composition of Empaneled Hospital Networks</Link></li>
            <li><Link to="/legal#division" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Medical Visa Law & Legal Divisions</Link></li>
            <li><Link to="/investigation" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Investigation & Hospital Quality Audits</Link></li>
            <li><Link to="/training" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Skill Development Facilitator Training</Link></li>
          </ul>
        </div>

        {/* CARD 5: PATIENT UTILITY DESK */}
        <div className="sitemap-block" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', borderTop: '4px solid #e056fd', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#e056fd', fontSize: '1.2rem', marginTop: '0', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1.4' }}>
            ⚡ Emergency & Support Actions
          </h3>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.95rem' }}>
            <li><Link to="/helpdesk#lodge" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Lodge & Track Medical Emergency Inquiries</Link></li>
            <li><Link to="/emergency#suomotu" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Suo-Motu Emergency Evacuation Cases</Link></li>
            <li><Link to="/investigation#spot" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Spot Inquiries / Hospital Verification Checks</Link></li>
            <li><Link to="/consult#open" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Open Video Cross-Border Consultations</Link></li>
          </ul>
        </div>

        {/* CARD 6: PUBLICATIONS & MEDIA */}
        <div className="sitemap-block" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', borderTop: '4px solid #6c5ce7', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#6c5ce7', fontSize: '1.2rem', marginTop: '0', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px', lineHeight: '1.4' }}>
            🎥 Media & Research Projects
          </h3>
          <ul style={{ listStyle: 'none', padding: '0', margin: '0', display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '0.95rem' }}>
            <li><Link to="/blogs#press" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Press Releases & Health Bulletins</Link></li>
            <li><Link to="/blogs#news" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Medical Trip World in News Media</Link></li>
            <li><Link to="/blogs#letters" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Monthly Patient Care Newsletters</Link></li>
            <li><Link to="/blogs#films" style={{ color: '#005ba1', textDecoration: 'none', display: 'inline-block', minHeight: '36px' }}>Patient Journey Short Documentaries</Link></li>
          </ul>
        </div>

      </div>

      {/* PLATFORM LEGAL FOOTER ANCHOR */}
      <div style={{ 
        textAlign: 'center', 
        fontSize: '0.85rem', 
        color: '#777', 
        maxWidth: '800px', 
        margin: '40px auto 0 auto', 
        lineHeight: '1.5', 
        borderTop: '1px solid #ddd', 
        paddingTop: '20px',
        boxSizing: 'border-box'
      }}>
        Medical Trip World operates exclusively as an open, independent informational sitemap directory. We do not provide statutory medical consulting, authorize hospital placement agreements, or hold legal clinical partnerships with featured corporate network institutions.
      </div>

    </div>
  );
}

export default Sitemap;